// Generated from SVG to Code Figma Plugin

import type { JSX } from 'react';

export const ArrowRight = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M23.5857 15.7071L17.2928 9.41421L18.707 8L27.4142 16.7071L18.707 25.4142L17.2928 24L23.5857 17.7071H6L6 15.7071H23.5857Z"
      fill="currentColor"
    />
  </svg>
);
